// ------------------------------- GLOBAL OBJECTS COMMONLY USED (CSS) --------------------------------------

import React from 'react';
import 'whatwg-fetch';
import _ from 'lodash';
import $ from 'jquery';
import SocialBarAppContainer from 'components/SocialBarAppContainer/SocialBarAppContainer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as SocialBarActions from './actions/SocialBarActions';
import I18nify from '@wix/restaurants-components-css-modules/dist/shared/I18nify';

import QueryUtils from '@wix/wixrest-utils/dist/QueryUtils';
import WixInstance from '@wix/wixrest-utils/dist/WixInstance';
import FacebookSignedRequest from '@wix/wixrest-utils/dist/FacebookSignedRequest';
import Wss from '@wix/wixrest-utils/dist/Wss';
import { create as fedopsLoggerCreate } from '@wix/fedops-logger';
import { Provider }                from 'react-redux';
import createConfiguredStore       from '@wix/restaurants-redux/dist/store/ConfigureReduxStore';
import * as WebInitActions         from '@wix/restaurants-redux/dist/actions/WebInitActions';
import * as FedopsActions from '@wix/restaurants-redux/dist/actions/FedopsActions';
import CssProvider from '@wix/restaurants-components-css-modules/dist/web/CssProvider/CssProvider';
import I18nWebProvider from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/I18nWebProvider';
import BI from '@wix/wixrest-bi/dist/BI';
import { clients } from 'wix-restaurants-js-sdk';
import moment from 'moment';
import ReactDOM from 'react-dom';

/******** REDUCERS ***********/
const reducers = {
    jointLoginInfo   : require('@wix/restaurants-redux/dist/reducers/JointLoginReducer').default,
    wixInstance      : require('@wix/restaurants-redux/dist/reducers/WixInstanceReducer').default,
    wixInstalledApps : require('@wix/restaurants-redux/dist/reducers/WixInstalledAppsReducer').default,
    i18nData          : require('@wix/restaurants-redux/dist/sagas/I18nSaga').default.reducer,
    organization     : require('@wix/restaurants-redux/dist/reducers/OrganizationReducer').default,
    styles           : require('@wix/restaurants-redux/dist/reducers/StylesReducer').default,
    socialBar        : require('./reducers/SocialBarReducer').default,
};

/******** SAGAS ***********/
const sagas = [
    require('./sagas/SocialBarSaga').default,
    require('@wix/restaurants-redux/dist/sagas/OrganizationSaga').default,
    require('@wix/restaurants-redux/dist/sagas/JointLoginSaga').default,
    require('@wix/restaurants-redux/dist/sagas/WebInitSaga').default,
    require('@wix/restaurants-redux/dist/sagas/WixInstalledAppsSaga').default,
    require('@wix/restaurants-redux/dist/sagas/FeedbackSaga').default,
    require('@wix/restaurants-redux/dist/sagas/WixBridgeSaga').default,
    require('@wix/wixrest-bi').redux.Saga,
    require('@wix/restaurants-redux/dist/sagas/WixStylesSaga').default,
    require('@wix/restaurants-redux/dist/sagas/FedopsSaga').default,
    require('@wix/restaurants-redux/dist/sagas/I18nSaga').default.saga
];

/******** SAGA PARAMS ***********/
import { WixApi }               from '@wix/wixrest-wix-api';
import OpenrestService          from 'openrest';
import uuid                     from 'node-uuid';
import Q                        from 'q';
import fedopsJson               from '../fedops.json';

const WIX_APP_IDS    = WixInstance.getAllAppIds();
const wixApi         = new WixApi({wixRestAppIds : WIX_APP_IDS});
const FB             = window.FB;
const Wix            = window.Wix;

const css = _.map($('style'), (style) => $(style).text().split('\n').join(' ')).join(' ');
const wss = window.wssSerialize ? new Wss(window.wssSerialize) : new Wss({css});
const fedopsLogger = fedopsLoggerCreate(fedopsJson['app_name']);

const sagaParams = {
    restClient: clients.createRestClient({timeout:0}),
    mappingClient: clients.createRestClient({timeout:0, baseUrl: 'https://mapping.wixrestaurants.com/v1'}),
    authentication: clients.createRestClient({timeout:0, baseUrl: 'https://auth.wixrestaurants.com/v2'}),
    WIX_APP_IDS,
    wixApi,
    OpenrestService,
    FB,
    fetch,
    Wix,
    uuid,
    window,
    Q,
    wss,
    fedopsLogger,
    fedopsJson
};

const initialState = _.isEmpty(window.__INITIAL_STATE__) ? undefined : window.__INITIAL_STATE__;
const confStore = {
    reducers,
    sagas,
    sagaParams,
    middlewares:[],
    useLogger:false
};

if (initialState) {
    confStore.initialState = initialState;
}

const store = createConfiguredStore(confStore);

function mapStateToProps(state) {
    return {
        organization: state.organization.organization,
        socialBar: state.socialBar,
        styles: state.styles.styles,
        i18nData: state.i18nData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        socialBarActions: bindActionCreators(SocialBarActions.actions, dispatch),
        fedopsActions: bindActionCreators(FedopsActions.actions, dispatch),
    };
}

const reportFirstRender = _.once(() => {
    if (typeof performance !== 'undefined' && typeof performance.mark === 'function') {
        performance.mark('[perfer] app-loaded');
    }
});

const SocialApp = connect(mapStateToProps, mapDispatchToProps)(class extends React.Component {
    componentDidMount() {
        const { fedopsActions } = this.props;
        fedopsActions.appLoaded();
        reportFirstRender();
    }

    render() {
        let { organization, socialBar, socialBarActions, i18nData } = this.props;
        let hasOrganization = _.isEmpty(organization);
        let content = hasOrganization ? <div></div> :
            <SocialBarAppContainer organization={organization}
                                   socialBarState={socialBar}
                                   socialBarActions={socialBarActions}/>;

        const dir = i18nData.localeData.dir;

        $(document.body).removeClass('ltr rtl');
        $(document.body).addClass(dir);
        $(document.body).attr('direction', dir);
        $(document.body).css('direction', dir);
        $(document.body).css('padding', '0px');
        $(document.body).css('margin', '0px');

        if (!this.removedLoader) {
            $('.__preloader').remove();
            this.removedLoader = true;
        }

        return content;
    }
});

const I18nWebProviderConnected = connect(function (state) {
    return {localeData: state.i18nData.localeData};
})(I18nWebProvider);
const CssProviderI18nified = I18nify(CssProvider);

function start() {
    if (Wix && Wix.Performance) {
        Wix.Performance.applicationLoadingStep(1, 'html-loaded');
    }

    let queryHash = QueryUtils.buildQueryHash();
    moment.relativeTimeThreshold('m', 10000); // No threshold to show minutes

    document.body.style.backgroundColor = 'transparent';

    window.START_APP_TIME = (new Date()).getTime();
    console.log('[Performance] Start app time', window.START_APP_TIME - window.LOAD_TIME);

    let facebookPageId = null;

    if (queryHash.facebookSignedRequest) {
        FacebookSignedRequest.init(queryHash.facebookSignedRequest);
        facebookPageId = FacebookSignedRequest.getPageId();
    }

    // Should we force a specific restaurant?
    let forceId = (() => {
        let paths = window.location.pathname.split('/');
        return (paths.length > 2) && (paths[1] === 'force') ? paths[2] : queryHash.organizationId;
    })();

    store.dispatch(WebInitActions.actions.initWeb({i18nUxMode: false, queryHash,
        appId: WixInstance.KIT_APP_ID, system: 'client', forceId, facebookPageId}));

    window.openrest = require('openrest'); // For debugging
    window.WixInstance = WixInstance;

    const state = store.getState();
    const wixInstance = _.get(state, 'wixInstance.instance');
    const organization = _.get(state, 'organization.organization');

    if (organization && wixInstance) {
        BI.init({
            organizationId: organization.id,
            metasiteId: wixInstance.getMetasiteId(),
            biToken: wixInstance.getBiToken(),
            instanceId: wixInstance.getInstanceId(),
            ownerId: wixInstance.getSiteOwnerId(),
            roles: wixInstance.getPermissions() || ''
        });

        sendLoadingBiEvent(queryHash.type);
    }

    ReactDOM.render(
        <Provider store={store}>
            <I18nWebProviderConnected Intl={Intl}>
                <CssProviderI18nified wss={wss}>
                    <SocialApp />
                </CssProviderI18nified>
            </I18nWebProviderConnected>
        </Provider>,
        document.getElementById('mainDiv')
    );
}

start();

function sendLoadingBiEvent (type) {
    let visitorId = '';
    let loadingTime = -1;

    try {
        loadingTime = Math.ceil(window.performance.now());
    } catch (e) {}

    try {
        visitorId = window.WixInstance.getVisitorId();
    } catch (e) {}

    BI.event(BI.EVENTS.LIVE_SITE_MENU_LOAD, {
        is_server_side_rendering: true,
        loading_time: loadingTime,
        product: type,
        visitorId
    });
}




// WEBPACK FOOTER //
// ./client.js